import { render, staticRenderFns } from "./ModelInfo2.vue?vue&type=template&id=7e2c88b0&scoped=true"
import script from "./ModelInfo2.vue?vue&type=script&lang=ts"
export * from "./ModelInfo2.vue?vue&type=script&lang=ts"
import style0 from "./ModelInfo2.vue?vue&type=style&index=0&id=7e2c88b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c88b0",
  null
  
)

export default component.exports